import { render, staticRenderFns } from "./use_zh.vue?vue&type=template&id=00bd4e74&"
import script from "./use_zh.vue?vue&type=script&lang=js&"
export * from "./use_zh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports